import { Box, VStack } from '@chakra-ui/react';
import { useTriggerForm } from '../useTriggerForm.js';
import EmailAddressInput from './EmailAddressInput';
import SubjectInput from './SubjectInput';
import HtmlBodyToggle from './HtmlBodyToggle';
import FieldsSelector from './FieldsSelector';
import BodyInput from './BodyInput';

const TriggerEmailAction = ({
    darkMode,
    fields,
    cursorPosition,
    setCursorPosition,
    errors,
    touched,
}) => {
    // Use context instead of Redux
    const { formData } = useTriggerForm();

    // Only show email action fields when Email is selected
    if (formData?.action?.actionType !== 'Email') return null;

    return (
        <VStack
            spacing={8}
            align="stretch"
            minHeight="fit-content"
            height="auto"
            flex="1">
            <Box width="100%" minHeight="fit-content" height="auto">
                <EmailAddressInput
                    darkMode={darkMode}
                    setCursorPosition={setCursorPosition}
                    errors={errors}
                    touched={touched}
                />
            </Box>

            <SubjectInput
                darkMode={darkMode}
                setCursorPosition={setCursorPosition}
                errors={errors}
                touched={touched}
            />

            <HtmlBodyToggle darkMode={darkMode} />

            <FieldsSelector
                darkMode={darkMode}
                fields={fields}
                cursorPosition={cursorPosition}
                setCursorPosition={setCursorPosition}
            />

            <BodyInput
                darkMode={darkMode}
                fields={fields}
                setCursorPosition={setCursorPosition}
                errors={errors}
                touched={touched}
            />
        </VStack>
    );
};

export default TriggerEmailAction;
